import { useState, useEffect } from "react";
import { QuestionDisplay } from "@/components/QuestionDisplay";
import { QuestionSettingsDialog } from "@/components/QuestionSettingsDialog";
import type { IQuestion } from "@/types/question";
import Loading from "@/components/shared/Loading";
import { getRandomEnabledSubtype } from "@/lib/settings";

export default function InductorQuestionsPage() {
  const [question, setQuestion] = useState<IQuestion | null>(null);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isVisible, setIsVisible] = useState(true);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const fetchQuestion = async () => {
    setIsVisible(false);
    await new Promise((resolve) => setTimeout(resolve, 100));

    try {
      const subtype = getRandomEnabledSubtype("circuits", "inductor");
      const url = `/api/questions/circuitanalysis?type=inductor&subtype=${subtype}`;
      const response = await fetch(url);
      const data = await response.json();
      setQuestion(data.data);
      setIsVisible(true);
    } catch (error) {
      console.error("Failed to fetch question:", error);
    }
  };

  useEffect(() => {
    const initialFetch = async () => {
      try {
        const subtype = getRandomEnabledSubtype("circuits", "inductor");
        const url = `/api/questions/circuitanalysis?type=inductor&subtype=${subtype}`;
        const response = await fetch(url);
        const data = await response.json();
        setQuestion(data.data);
      } catch (error) {
        console.error("Failed to fetch question:", error);
      } finally {
        setIsInitialLoading(false);
      }
    };
    initialFetch();
  }, []);

  if (isInitialLoading) {
    return <Loading />;
  }

  if (!question) {
    return <div>Failed to load question</div>;
  }

  return (
    <div className="container mx-auto qa">
      <div className={`transition-opacity duration-250 ease-in-out ${isVisible ? "opacity-100" : "opacity-0"}`}>
        <QuestionDisplay
          question={question}
          onNext={fetchQuestion}
          onSettingsClick={() => setIsSettingsOpen(true)}
        />
      </div>

      <QuestionSettingsDialog
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
        questionType="inductor"
      />
    </div>
  );
}
